<template>
    <div class="team">
        <!-- banner -->
        <div class="banner">
            <p>海内外mentor咨询团队</p>
        </div>
        <p class="team_title">创始人团队</p>
        <ul class="list">
            <li v-for="(item,index) in founderList" :key="index">
                <div class="top">
                    <img :src="item.image" alt="">
                    <div class="info">
                        <p class="name">{{item.name}}</p>
                        <p class="title">{{item.title}}</p>
                    </div>
                </div>
                <div class="content">
                    {{item.content}}
                </div>
            </li>
        </ul>
        <!--计算机科学-->
        <p class="team_title">计算机科学</p>
        <ul class="list">
            <li v-for="(item,index) in CSTeamList" :key="index" v-if="index < CSNumber">
                <div class="top">
                    <img :src="item.image" alt="">
                    <div class="info">
                        <p class="name">{{item.name}}</p>
                        <p class="title">{{item.title}}</p>
                        <!--<p class="evaluate">工作评价 ></p>-->
                    </div>
                </div>
                <div class="content">
                    {{item.content}}
                </div>
                <div class='evaluate' v-if="item.evaluate.length > 0">
                    工作评价:
                    <p v-for="(list,index_) in item.evaluate" :key="index_">
                        <span class="dian"></span>
                        <span class="data">{{list}}</span>
                    </p>
                </div>
            </li>
            <p class="more" v-if="CSNumber == 4" @click="getMore('cs')">更多 <span class="icon van-icon van-icon-arrow-down"></span></p>
            <p class="more" v-if="CSNumber == CSTeamList.length" @click="getLess('cs')">收起 <span class="icon van-icon van-icon-arrow-up"></span></p>
        </ul>
        <!--MFE/BA/DS-->
        <p class="team_title">MFE/BA/DS</p>
        <ul class="list">
            <li v-for="(item,index) in MFETeamList" :key="index" v-if="index < MFENumber">
                <div class="top">
                    <img :src="item.image" alt="">
                    <div class="info">
                        <p class="name">{{item.name}}</p>
                        <p class="title">{{item.title}}</p>
                        <!--<p class="evaluate">工作评价 ></p>-->
                    </div>
                </div>
                <div class="content">
                    {{item.content}}
                </div>
                <div class='evaluate' v-if="item.evaluate.length > 0">
                    工作评价:
                    <p v-for="(list,index_) in item.evaluate" :key="index_">
                        <span class="dian"></span>
                        <span class="data">{{list}}</span>
                    </p>
                </div>
            </li>
            <p class="more" v-if="MFENumber == 4" @click="getMore('mfe')">更多 <span class="icon van-icon van-icon-arrow-down"></span></p>
            <p class="more" v-if="MFENumber == MFETeamList.length" @click="getLess('mfe')">收起 <span class="icon van-icon van-icon-arrow-up"></span></p>
        </ul>
        <!--商科/经济学-->
        <p class="team_title">商科/经济学</p>
        <ul class="list">
            <li v-for="(item,index) in BSTeamList" :key="index" v-if="index < BSNumber">
                <div class="top">
                    <img :src="item.image" alt="">
                    <div class="info">
                        <p class="name">{{item.name}}</p>
                        <p class="title">{{item.title}}</p>
                        <!--<p class="evaluate">工作评价 ></p>-->
                    </div>
                </div>
                <div class="content">
                    {{item.content}}
                </div>
                <div class='evaluate' v-if="item.evaluate.length > 0">
                    工作评价:
                    <p v-for="(list,index_) in item.evaluate" :key="index_">
                        <span class="dian"></span>
                        <span class="data">{{list}}</span>
                    </p>
                </div>
            </li>
            <p class="more" v-if="BSNumber == 4" @click="getMore('bs')">更多 <span class="icon van-icon van-icon-arrow-down"></span></p>
            <p class="more" v-if="BSNumber == BSTeamList.length" @click="getLess('bs')">收起 <span class="icon van-icon van-icon-arrow-up"></span></p>
        </ul>
    </div>
</template>

<script>
import teamData from './teamData'
export default {
    data() {
        return {
            // 创始人
            founderList: [{
                name: "龚晓然",
                title: "世毕盟创始人",
                image: require("@/assets/img/team/gong.jpeg"),
                content: "留学教父，世毕盟创始人，清华大学硕士， 过去10年其讲授的【世毕盟申请课程】指导超过1000名学员进入哈佛、MIT，斯坦福和普林斯顿大学。"
            }, {
                name: "吴靖",
                title: "世毕盟联合创始人",
                image: require("@/assets/img/team/wu.jpeg"),
                content: "世毕盟联合创始人，世毕盟商科首席咨询师，斯坦福、伯克利等10余所名校博士全奖获得者；清华大学学士，芝加哥大学商学院MBA、博士。"
            }, {
                name: "向凯",
                title: "世毕盟联合创始人",
                image: require("@/assets/img/team/xiang.jpeg"),
                content: "世毕盟联合创始人，世毕盟材料工程首席咨询师，清华大学工学学士、经济学学士，美国麻省理工学院材料工程专业博士。"
            }, {
                name: "张宇昊",
                title: "世毕盟联合创始人",
                image: require("@/assets/img/team/zhang.jpeg"),
                content: "北京大学理学学士，麻省理工EE博士，横扫MIT、Stanford、Berkeley、Caltech、Cambridge等顶级名校offers，世毕盟EECS及理科首席咨询师。"
            }],
            // 计算机科学
            CSTeamList: teamData.CSMentorTeam,
            CSNumber:4,
            // MFE/BA/DS
            MFETeamList: teamData.MFEMentor,
            MFENumber:4,
            // 商科/经济学
            BSTeamList: teamData.BSMentor,
            BSNumber: 4,
            // 数学/统计/应数/运筹
            MathTeamList: teamData.MathMentor,
            MathNumber: 4,
            // 物理/电子/材料/机械
            PhysTeamList: teamData.PhysMentor,
            PhysNumber: 4,
            // 化学/生物/土木/环境/公卫
            ChemTeamList: teamData.ChemMentor,
            ChemNumber: 4,
            // 社科文艺
            SSCITeamList: teamData.SSCIMentor,
            SSCINumber: 4,
            wxImg: "http://www.gguconsulting.com/try/sbm/Public/img/ggu_logo.jpg",
        }
    },
    methods:{
        getMore(data){
            if(data == 'cs'){
                this.CSNumber = this.CSTeamList.length;
            }else if(data == 'mfe'){
                this.MFENumber = this.MFETeamList.length;
            }else if(data == 'bs'){
                this.BSNumber = this.BSTeamList.length;
            } else if (data == 'math') {
                this.MathNumber = this.MathTeamList.length;
            } else if (data == 'phys') {
                this.PhysNumber = this.PhysTeamList.length;
            } else if (data == 'chem') {
                this.ChemNumber = this.ChemTeamList.length;
            } else if (data == 'ssci') {
                this.SSCINumber = this.SSCITeamList.length;
            }
        },
        getLess(data){
            if(data == 'cs'){
                this.CSNumber = 4;
            }else if(data == 'mfe'){
                this.MFENumber = 4;
            }else if(data == 'bs'){
                this.BSNumber = 4;
            } else if (data == 'math') {
                this.MathNumber = 4;
            } else if (data == 'phys') {
                this.PhysNumber = 4;
            } else if (data == 'chem') {
                this.ChemNumber = 4;
            } else if (data == 'ssci') {
                this.SSCINumber = 4;
            }
        },
    },
    mounted(){

    },
    created() {
        // this.WXConfig.wxShowMenu("海内外mentor咨询团队","美英top名校申请专家，让你脱颖而出！","http://www.gguconsulting.com/try/sbm/index.php/#/team",this.wxImg);
    },
}
</script>

<style lang="less" scoped>
.team {
    background:#fff;
    padding-bottom:180px;
    // font-family: 'PingFang Regular';
    .banner {
        width: 100%;
        height: 240px;
        position: relative;
        background:url("../../assets/img/team_banner.jpg");
        background-size:auto 100%;
        p {
            padding-top: 90px;
            text-align: center;
            font-size: 47px;
            color: #fff;
            span {
                color: #FEEA8B;
            }
        }
    }
    .team_title{
        text-align: center;
        color:#1A1A1A;
        font-size: 38px;
        padding:100px 0 50px;
        line-height: 38px;
    }
    .list{
        margin-top:30px;
        padding:0 30px 80px;
        border-bottom:20px solid #F5F5F5;
        position:relative;
        li{
            border:1px solid #903;
            border-radius:10px;
            margin-bottom:50px;
            // padding:20px 30px;
            .top{
                display:flex;
                padding:10px;
                img{
                    width:150px;
                    height:150px;
                    border-radius:10px;
                }
                .info{
                    margin-left:20px;
                    flex:1;
                    .name{
                        font-size:30px;
                        margin-top:25px;
                        font-weight:600;
                    }
                    .title{
                        font-size:26px;
                        margin-top:10px;
                    }
                }
            }
            .content{
                font-size:26px;
                line-height:44px;
                // margin-top:20px;
                padding:0px 30px 30px;
                // text-align: justify;
            }
            .evaluate{
                border-top:1px solid #903;
                padding:30px;
                font-size:26px;
                line-height:44px;
                p{
                    margin-top:10px;
                    padding-left:25px;
                    position:relative;
                    .dian{
                        width:8px;
                        height:8px;
                        background:#903;
                        border-radius:50%;
                        position:absolute;
                        top:18px;
                        left:0;
                    }
                }
            }
        }
        &.list_{
            .top{
                .info{
                    .name{
                        margin-top:10px;
                    }
                    .title{
                        margin-top:0px;
                    }
                }
            }
        }
        .more{
            position:absolute;
            bottom:30px;
            right:50px;
            font-size:30px;
        }
        &:last-child{
            border-bottom:none;
        }
    }

}
</style>